import React from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { connect } from "react-redux";

import translate from "../../i18n/translate";
import DynamicLogo from "shared/components/DynamicLogo";

// The settings area, nine pages. Order follows how often each is opened:
// the gateways and operators that decide whether a sale goes through come
// first, the rarely touched system page last.
const PAGES = [
  { icon: "🔌", title: translate("Providers"), linkTo: "/admin/providers" },
  { icon: "📡", title: translate("Operators"), linkTo: "/admin/operators" },
  { icon: "💸", title: translate("Commissions"), linkTo: "/admin/commissions" },
  { icon: "🎁", title: translate("Gift cards & games"), linkTo: "/admin/giftcards" },
  { icon: "💬", title: translate("Messaging"), linkTo: "/admin/messaging" },
  { icon: "🧩", title: translate("Services"), linkTo: "/admin/services" },
  { icon: "🔐", title: translate("Users & access"), linkTo: "/admin/access" },
  { icon: "🛠️", title: translate("Tools"), linkTo: "/admin/tools" },
  { icon: "⚙️", title: translate("system"), linkTo: "/admin/system" },
];

const AdminSideBar = ({ isDarktheme }) => {
  const history = useHistory();
  const location = useLocation();
  const current = location.pathname.toLowerCase();

  return (
    <div className={!isDarktheme ? "admin-sidebar2" : "dark-admin-sidebar2"}>
      <div className={!isDarktheme ? "admin-sidebar2-Logo" : "dark-admin-sidebar2-Logo"}>
        <a className="admin-logo" onClick={() => history.push("/")} href="#0">
          <DynamicLogo width="auto" height="40" className="d-inline-block align-top " />
        </a>
      </div>
      <div style={{ width: "290px", paddingLeft: 16, paddingRight: 16 }}>
        {PAGES.map((page) => {
          const active = current.startsWith(page.linkTo.toLowerCase());
          return (
            <Link to={page.linkTo} key={page.linkTo}>
              <p
                style={{
                  color: "white",
                  margin: "6px 0",
                  padding: "9px 12px",
                  borderRadius: 8,
                  background: active ? "rgba(255,255,255,0.12)" : "transparent",
                  fontWeight: active ? 600 : 400,
                }}
              >
                <span style={{ display: "inline-block", width: 28 }}>{page.icon}</span>
                {page.title}
              </p>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

const mapStateToProps = ({ darkTheme: { isDarktheme } }) => {
  return {
    isDarktheme,
  };
};

export default connect(mapStateToProps, null)(AdminSideBar);
